// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .chapters-menu-item_wrapper__M\\+UhS:hover {
    outline: 2px solid var(--primaryColor);
  }
.chapters-menu-item_content__7LJgD {
  cursor: pointer;

  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 100%;
  margin: 0;
  padding: 0;
  padding: 18px 20px;
}

.chapters-menu-item_header__HVNcI {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.chapters-menu-item_thumbnail__B1jNX {
  flex-shrink: 0;

  width: 80px;
  height: 45px;

  background-color: rgba(217, 217, 217, 1);
  background-size: cover;
}

.chapters-menu-item_titleTimeWrapper__Qud4\\+ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.chapters-menu-item_title__oYTii {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  font-size: 14px;
  font-weight: 700;
  line-height: 14.63px;
  color: var(--textColor);
  text-align: left;
}

.chapters-menu-item_startTime__joWr8 {
  flex-shrink: 0;

  padding: 2px 10px 2px 10px;
  border-width: 0;
  border-radius: 3px;

  font-size: 12px;
  font-weight: 700;
  color: #ffffff;

  background: rgba(0, 0, 0, 0.5);
}

.chapters-menu-item_startTime__joWr8.chapters-menu-item_active__mHY5d {
    background: var(--primaryColor);
  }

.chapters-menu-item_description__g-3GM {
  font-size: 12px;
  font-weight: 500;
  line-height: 14.63px;
  color: var(--textColor);
  text-align: left;
}

/* Smaller screens / mobile */
.smallScreen .chapters-menu-item_wrapper__M\\+UhS:not(:last-child)::after {
    content: '';

    display: block;

    width: 100%;
    height: 1px;

    background: rgba(124, 124, 124, 1);
  }
.smallScreen .chapters-menu-item_thumbnail__B1jNX {
    display: none;
  }
.smallScreen .chapters-menu-item_titleTimeWrapper__Qud4\\+ {
    flex-direction: column-reverse;
    gap: 10px;
    align-items: flex-start;
  }
.smallScreen .chapters-menu-item_description__g-3GM {
    display: none;
  }
`, "",{"version":3,"sources":["webpack://./src/components/chapters-menu/chapters-menu-item.module.css"],"names":[],"mappings":";EACE;IACE,sCAAsC;EACxC;AAEF;EACE,eAAe;;EAEf,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,WAAW;EACX,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;;EAEd,WAAW;EACX,YAAY;;EAEZ,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;;EAErB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;;EAElB,eAAe;EACf,gBAAgB;EAChB,cAAc;;EAEd,8BAA8B;AAKhC;;AAHE;IACE,+BAA+B;EACjC;;AAGF;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,6BAA6B;AAE3B;IACE,WAAW;;IAEX,cAAc;;IAEd,WAAW;IACX,WAAW;;IAEX,kCAAkC;EACpC;AAEA;IACE,aAAa;EACf;AAEA;IACE,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;EACzB;AAEA;IACE,aAAa;EACf","sourcesContent":[".wrapper {\n  &:hover {\n    outline: 2px solid var(--primaryColor);\n  }\n}\n.content {\n  cursor: pointer;\n\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  padding: 18px 20px;\n}\n\n.header {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  width: 100%;\n}\n\n.thumbnail {\n  flex-shrink: 0;\n\n  width: 80px;\n  height: 45px;\n\n  background-color: rgba(217, 217, 217, 1);\n  background-size: cover;\n}\n\n.titleTimeWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.title {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 14.63px;\n  color: var(--textColor);\n  text-align: left;\n}\n\n.startTime {\n  flex-shrink: 0;\n\n  padding: 2px 10px 2px 10px;\n  border-width: 0;\n  border-radius: 3px;\n\n  font-size: 12px;\n  font-weight: 700;\n  color: #ffffff;\n\n  background: rgba(0, 0, 0, 0.5);\n\n  &.active {\n    background: var(--primaryColor);\n  }\n}\n\n.description {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14.63px;\n  color: var(--textColor);\n  text-align: left;\n}\n\n/* Smaller screens / mobile */\n:global(.smallScreen) {\n  & .wrapper:not(:last-child)::after {\n    content: '';\n\n    display: block;\n\n    width: 100%;\n    height: 1px;\n\n    background: rgba(124, 124, 124, 1);\n  }\n\n  & .thumbnail {\n    display: none;\n  }\n\n  & .titleTimeWrapper {\n    flex-direction: column-reverse;\n    gap: 10px;\n    align-items: flex-start;\n  }\n\n  & .description {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `chapters-menu-item_wrapper__M+UhS`,
	"content": `chapters-menu-item_content__7LJgD`,
	"header": `chapters-menu-item_header__HVNcI`,
	"thumbnail": `chapters-menu-item_thumbnail__B1jNX`,
	"titleTimeWrapper": `chapters-menu-item_titleTimeWrapper__Qud4+`,
	"title": `chapters-menu-item_title__oYTii`,
	"startTime": `chapters-menu-item_startTime__joWr8`,
	"active": `chapters-menu-item_active__mHY5d`,
	"description": `chapters-menu-item_description__g-3GM`
};
export default ___CSS_LOADER_EXPORT___;
